import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import { ROOT_MODAL_DRAWER_PROP } from 'components/Drawers/standardDrawerContract';
import type { RootModalDrawerOptions } from 'components/Drawers/standardDrawerContract';
import type { ScheduledTransaction } from 'app-components/flux/scheduled-transactions/scheduledTransactionsTypes';
import type { TransactionProps, TransactionRecord } from 'app-components/flux/transactions/transactionsTypes';
import { Map as ImmutableMap } from 'immutable';
import { createAction } from 'redux-actions';

export const DIALOG_TYPE = 'VIEW_SERIES_DIALOG';

type ViewSeriesDialogTxn = TransactionRecord | TransactionProps | (ScheduledTransaction & { stModelId?: string });

type ShowViewSeriesDialogOptions = {
  rootModalDrawer?: RootModalDrawerOptions;
  txn: ViewSeriesDialogTxn;
};

type ShowViewSeriesDialogPayload = ShowViewSeriesDialogOptions | ViewSeriesDialogTxn;

const isShowViewSeriesDialogOptions = (payload: ShowViewSeriesDialogPayload): payload is ShowViewSeriesDialogOptions =>
  typeof payload === 'object' && payload !== null && 'txn' in payload;

export const showViewSeriesDialog = createAction(
  rootUiActions.createDialog.toString(),
  (payload: ShowViewSeriesDialogPayload) => {
    const dialogOptions = isShowViewSeriesDialogOptions(payload) ? payload : undefined;
    const txn = dialogOptions?.txn ?? payload;
    const rootModalDrawer = dialogOptions?.rootModalDrawer;

    return rootUiTypes.mkRootUiData({
      type: DIALOG_TYPE,
      allowNesting: true,
      props: ImmutableMap({
        txn,
        ...(rootModalDrawer ? { [ROOT_MODAL_DRAWER_PROP]: rootModalDrawer } : {}),
      }),
    });
  },
);
